import React from 'react'
import styled from 'styled-components'
import { ReactComponent as SettingsIcon } from '../assets/img/svg/settings.svg'
import { FormattedMessage } from 'react-intl'

export default function FilterButton({
  filterCount,
  onClick,
  isActive: dataActive,
}) {
  return (
    <Button onClick={onClick} data-active={dataActive}>
      <SettingsIcon />
      <FormattedMessage id="Filters" />
      {filterCount > 0 && <small>{filterCount}</small>}
    </Button>
  )
}

const Button = styled.button`
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1rem;
  border: 1px solid #d8d8d8;
  border-radius: 6px;
  background-color: #fff;
  color: #2d3748;
  gap: 0.625rem;

  &:focus-visible {
    outline: #a6a4a4 auto 2px;
  }

  &:focus {
    outline: #a6a4a4 auto 2px;
  }

  &.filter-button[data-active='true'] {
    background-color: #f9f9f9;
  }

  small {
    width: 20px;
    height: 20px;
    background: #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
`
